import { Data as ArticleData, StreamElement } from '@root/modules/article/types/article';

export default function getStreamElement(article: ArticleData) {
  const attributes = article.settings;

  const isStream = attributes.streamEventStart && attributes.streamEventEnd;
  if (isStream) {
    const streamElement: StreamElement = {};
    const streamData = article.content.leadElement.content[0].attrs.streamData;
    streamElement.videoCode = streamData?.videoPlaylistLocation;
    streamElement.provider = streamData?.videoVendorId;
    streamElement.start = attributes.streamEventStart;
    streamElement.end = attributes.streamEventEnd;
    streamElement.hasPostLiveRecording = attributes.videoStreamPostLiveRecording || attributes.hasPostLiveRecording;

    return streamElement;
  }

  return null;
}
